<div class="dialog-panel">
    <div class="header">
        <h3 class="dialog-panel-header-title">{{ header }}</h3>
    </div>
</div>
